var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.workersn},[_c('iframe',{ref:"customerIframe",class:_vm.$style.customerIframe,attrs:{"name":"customerIframe","src":_vm.workerSnUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }